import {ErrorBoundary, Observer, RunInAction} from "web-vcore";
import {Clone} from "js-vextensions";
import {Column, Row, Text} from "react-vcomponents";
import {BaseComponentPlus} from "react-vextensions";
import {liveSession} from "../../../Engine/LiveSessionManagement.js";
import {store} from "../../../Store/index.js";
import {SessionManagementPanel_Client} from "./ClientPanel/SessionManagementPanel.js";
import {Alarms_ConfigUI} from "./SessionTabPanels/Alarms_ConfigUI.js";
import {Background_ConfigUI} from "./SessionTabPanels/Background_ConfigUI.js";
import {DreamNarration_ConfigUI} from "./SessionTabPanels/DreamNarration_ConfigUI.js";
import {EffectCountsPanel} from "./SessionTabPanels/EffectCountsPanel.js";
import {General_ConfigUI} from "./SessionTabPanels/General_ConfigUI.js";
import {EngineConfigChangerFunc, FixEngineConfigButton, JSONEngineConfigButton, ResetEngineConfigButton} from "./ConfigPanel_Local.js";
import React from "react";
import {observer_mgl} from "mobx-graphlink";

export const EngineConfigPanel_Client = observer_mgl(()=>{
	//engineContext: State(a=>a.main.engine.config.engineContext),
	const channel = store.main.engine.config.remote_channel;
	const hostIPAddressAndPort = store.main.engine.config.remote_hostIPAddressAndPort;
	const config = store.main.engine.config.remoteConfig;
	/*snoozeFailTrigger_volumeKeys: State(a=>a.main.engine.config.remote_snoozeFailTrigger_volumeKeys),
	snoozeFailTrigger_micLoudness: State(a=>a.main.engine.config.remote_snoozeFailTrigger_micLoudness),
	snoozeFailTrigger_micLoudness_loudness: State(a=>a.main.engine.config.remote_snoozeFailTrigger_micLoudness_loudness),*/
	const tracker1 = store.main.engine.config.liveSession_setAt;
	//const active = liveSession != null;
	const active = liveSession != null && liveSession.IsClient();
	const enabled = store.main.settings.configChangeDuringSession == "allow" ? true : !active;

	const ChangeConfig = (configChangerFunc: EngineConfigChangerFunc)=>{
		const newConfig = Clone(config);
		// maybe temp; for now just strip away any properties that aren't recognized (fixes error after code upgrades that change property names)
		/*g.oldConfigs = (g.oldConfigs || []).concat(localConfig);
		newConfig = newConfig.IncludeKeys(...GetSchemaJSON("EngineConfig").properties.VKeys());*/

		configChangerFunc(newConfig);
		RunInAction("RemotePanel_ChangeConfig", ()=>store.main.engine.config.remoteConfig = newConfig);
		//new UpdateEngineConfig({id: config.id, updates: GetUpdates(config, newConfig)}).RunOnServer();
	};

	//const largeVersion = window.outerWidth >= 1024;
	const sharedProps = {client: true, enabled, active, config_full: config, ChangeConfig_Full: ChangeConfig};
	return (
		<Row>
			<Column style={{flex: 1}}>
				<SessionManagementPanel_Client {...sharedProps}/>
				<Row>
				<Text>Config:</Text>
				<JSONEngineConfigButton {...sharedProps}/>
				<FixEngineConfigButton {...sharedProps}/>
				<ResetEngineConfigButton {...sharedProps}/>
			</Row>
				<ErrorBoundary /*errorUI={(defaultUI, boundary)=>{
					return (
						<Column>
							<Row>
								<Button mb={5} text="Reset config" onClick={()=>{
									const keysToRemove = config.VKeys(true).filter(key=>GetSchemaJSON("EngineConfig").properties[key] == null);
									ShowMessageBox({
										title: "Reset FBA-remote config?", cancelButton: true,
										message: `
											Clear all invalid options, and reset all valid options to their defaults?

											Keys to remove:${keysToRemove.length == 0 ? " (none)" : keysToRemove.map(key=>`\n* ${key}: ${config[key]}`).join("")}
											Keys to reset:${EngineConfig_default.VKeys(true).map(key=>`\n* ${key}: ${EngineConfig_default[key]}`).join("")}
										`.AsMultiline(0),
										onOK: ()=>{
											/*g.oldConfigs = (g.oldConfigs || []).concat(config);
											ChangeConfig(c=>c.VSet(EngineConfig_default));*#/
											ChangeConfig(c=>{
												// remove invalid
												for (const key of keysToRemove) {
													delete c[key];
												}
												// reset valid
												c.VSet(new EngineConfig({}));
												// try to restore normal ui
												boundary.ClearError();
											});
										},
									});
								}}/>
							</Row>
							{defaultUI}
						</Column>
					);
				}}*/>
					<EffectCountsPanel {...sharedProps}/>
					<General_ConfigUI {...sharedProps}/>
					<Background_ConfigUI {...sharedProps}/>
					{/*<CameraPanel {...sharedProps}/>
					<GyroPanel {...sharedProps}/>
					<EEGPanel {...sharedProps}/>*/}
					<Alarms_ConfigUI {...sharedProps}/>
					<DreamNarration_ConfigUI {...sharedProps}/>
				</ErrorBoundary>
			</Column>
		</Row>
	);
});